import { ClassNameMap, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Theme, Tooltip } from "@mui/material";
import { ReactComponent as PlantSummaryIcon } from './SideNav-assets/PlantSummary.svg';
import { useNavigate, useLocation } from "react-router-dom";

interface PlantSummaryItemProps {
    isPlantSummaryRoles: (userpermission: string[]) => boolean
    usersList: any
    theme: Theme
    isDrawerOpen: boolean
    classes: ClassNameMap
}

const PlantSummaryListItem = ({ isPlantSummaryRoles, usersList, theme, isDrawerOpen, classes }: PlantSummaryItemProps) => {

    const navigate = useNavigate();
    const location = useLocation();
    const { paper, default: defaultBG } = theme.palette.background;
    const backgroundColor = location.pathname === "/dashboard" ? defaultBG : paper;


    const navigateToPlantSummary = () => {
        navigate("/dashboard");
    }

    return (
        <div>
            {isPlantSummaryRoles(usersList.currentUserPermissions) && (
                <ListItem
                    disablePadding
                    className={classes.iconSection}
                    sx={{ backgroundColor }}
                >
                    <ListItemButton
                        disableRipple
                        className={classes.iconSectionButtons}
                        onClick={() => navigateToPlantSummary()}
                    >
                        <ListItemIcon
                            sx={{
                                paddingLeft: isDrawerOpen ? "16px" : "",
                                minWidth: 0,
                                mx: 'auto',
                                justifyContent: 'center',
                                alignContent: "center",
                                color: 'white'
                            }}
                        >
                            {isDrawerOpen ? <PlantSummaryIcon /> : <Tooltip title='Plant Summary' placement='right'><PlantSummaryIcon /></Tooltip>}
                        </ListItemIcon>
                        {isDrawerOpen && <ListItemText
                            primary={'Plant Summary'}
                            sx={{ opacity: 1, color: 'white', ml: 3 }}
                        />}
                    </ListItemButton>
                </ListItem>
            )}
        </div>
    )
}

export default PlantSummaryListItem